import React, { useEffect, useState } from "react";
import { Button, styled, Typography } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import {
  getGames,
  addGame,
  removeGame,
  uploadGameImage,
} from "../../api/games.api";
import CreateGameModal from "../../components/modals/createGame.modal.js";
import DeleteIcon from "@mui/icons-material/Delete";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { useSnackbar } from "../../context/snackbar.context.js";

const AdminGamesPage = () => {
  const showSnackbar = useSnackbar();
  const [openModal, setOpenModal] = useState(false);
  const [games, setGames] = useState([]);
  const [refreshGames, setRefreshGames] = useState(false);

  useEffect(() => {
    getGames().then((response) => {
      setGames(response.data);
    });
  }, [refreshGames]);

  const handleSubmit = (formData) => {
    addGame(formData)
      .then(() => {
        setRefreshGames((prev) => !prev);
        showSnackbar("Game created!", "success");
      })
      .catch(() => showSnackbar("Failed to create Game!", "error"));
  };

  const handleRemove = (id) => {
    removeGame(id)
      .then(() => {
        setRefreshGames((prev) => !prev);
        showSnackbar("Game deleted!", "success");
      })
      .catch(() => showSnackbar("Failed to remove Game!", "error"));
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleUpload = (id, file) => {
    uploadGameImage(id, file)
      .then((response) => {
        if (response.data) {
          showSnackbar("Image uploaded!", "success");
        } else {
          showSnackbar("Could not upload Image!", "error");
        }
      })
      .catch(() => {
        showSnackbar("Could not upload Image!", "error");
      });
  };

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  return (
    <div>
      <Typography variant="h3" gutterBottom>
        Games Administration
      </Typography>
      <TableContainer>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Game Name</TableCell>
              <TableCell>Category</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {games.map((row) => (
              <TableRow
                key={row.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row.name}
                </TableCell>
                <TableCell>{row.category}</TableCell>
                <TableCell>
                  <Button
                    component="label"
                    role={undefined}
                    variant="contained"
                    tabIndex={-1}
                    startIcon={<FileUploadIcon />}
                  >
                    Upl. Image
                    <VisuallyHiddenInput
                      type="file"
                      onChange={(event) =>
                        handleUpload(row.id, event.target.files[0])
                      }
                    />
                  </Button>
                  <Button
                    sx={{ml:1}}
                    variant="outlined"
                    onClick={() => handleRemove(row.id)}
                    startIcon={<DeleteIcon />}
                  >
                    Delete
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Button variant="contained" onClick={handleOpenModal} sx={{ mt: 1 }}>
        Create Game
      </Button>

      <CreateGameModal
        aria-modal
        open={openModal}
        handleClose={handleCloseModal}
        handleSubmit={handleSubmit}
      />
    </div>
  );
};

export default AdminGamesPage;
